import { render, staticRenderFns } from "./CheckboxField.vue?vue&type=template&id=1524f63b&"
import script from "./CheckboxField.vue?vue&type=script&lang=ts&"
export * from "./CheckboxField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports